export const SEND_FILTERS = "SEND_FILTERS";
export const RESET_FILTER_PAYLOAD = "RESET_FILTER_PAYLOAD";
